import styled from 'styled-components';
import { BaseButton } from '.';

export const ProfilePanelButton = styled(BaseButton)`
  height: 28px;
`;
